// src/pages/polls/PollsOverlayPage.jsx
import React, { useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";
import { POLLS_API, getRoomCodeFromQuery } from "./pollsApi";

export default function PollsOverlayPage() {
    const roomCode = getRoomCodeFromQuery();
    const [active, setActive] = useState(null);
    const [results, setResults] = useState(null);
    const socketRef = useRef(null);

    useEffect(() => {
        // Transparenz wirklich erzwingen (falls global CSS was setzt)
        document.documentElement.style.background = "transparent";
        document.body.style.background = "transparent";
        document.body.style.margin = "0";
        document.body.style.padding = "0";

        return () => {
            // nichts nötig
        };
    }, []);

    useEffect(() => {
        if (!roomCode) return;

        const s = io(POLLS_API, { transports: ["websocket"] });
        socketRef.current = s;

        s.emit("joinRoom", { roomCode });
        s.on("activeQuestion", (q) => setActive(q));
        s.on("results", (r) => setResults(r));

        return () => {
            s.disconnect();
            socketRef.current = null;
        };
    }, [roomCode]);

    const wrap = {
        position: "fixed",
        inset: 0,                 // statt 100vw/100vh
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "flex-end",
        padding: 32,
        boxSizing: "border-box",  // <- wichtig! padding zählt in die Breite rein
        fontFamily: "system-ui",
        color: "#fff",
        background: "rgba(0,0,0,0)"
    };

    const card = {
        width: "min(760px, calc(100vw - 64px))",   // <- 64px = 2*PADDING
        maxWidth: "calc(100vw - 64px)",
        borderRadius: 22,
        padding: 20,
        boxSizing: "border-box",
        background: "rgba(35,47,45,0.78)",
        border: "1px solid rgba(228,254,60,0.20)",
        boxShadow: "0 16px 50px rgba(0,0,0,0.35)"
    };

    if (!roomCode) {
        return (
            <div style={wrap}>
                <div style={card}>Fehlt: ?code=gt3x-r1</div>
            </div>
        );
    }

    if (!active) {
        return (
            <div style={wrap}>
                <div style={card}>Kein aktives Voting.</div>
            </div>
        );
    }

    const total = results?.total || 0;
    const showResults = !!(active.showResults || results?.show);

    return (
        <div style={wrap}>
            <div style={card}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 12 }}>
                    <div style={{ fontSize: 24, fontWeight: 900, lineHeight: 1.1 }}>
                        {active.title}
                        {active.timestamp ? (
                            <span style={{ marginLeft: 10, opacity: 0.75, fontSize: 18 }}>
                ({active.timestamp})
              </span>
                        ) : null}
                    </div>
                    <div style={{ opacity: 0.80, fontSize: 18 }}>Votes: {total}</div>
                </div>

                {!showResults ? (
                    <div style={{ marginTop: 14, display: "grid", gap: 10 }}>
                        {active.options.map((opt) => (
                            <div
                                key={opt}
                                style={{
                                    padding: "12px 14px",
                                    borderRadius: 16,
                                    background: "rgba(255,255,255,0.06)",
                                    border: "1px solid rgba(255,255,255,0.10)"
                                }}
                            >
                                <div style={{ fontSize: 18 }}>{opt}</div>
                            </div>
                        ))}

                        <div style={{ marginTop: 10, opacity: 0.85, fontSize: 16 }}>
                            Abstimmen: <b>racevision.info/polls/room?code={roomCode}</b>
                        </div>
                    </div>
                ) : (
                    <div style={{ marginTop: 16 }}>
                        {active.options.map((opt) => {
                            const c = results?.counts?.[opt] || 0;
                            const pct = total ? Math.round((c / total) * 100) : 0;

                            return (
                                <div key={opt} style={{ marginBottom: 12 }}>
                                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                                        <div style={{ fontSize: 18 }}>{opt}</div>
                                        <div style={{ fontSize: 18, opacity: 0.85 }}>
                                            {pct}% ({c})
                                        </div>
                                    </div>

                                    <div
                                        style={{
                                            height: 14,
                                            borderRadius: 999,
                                            background: "rgba(255,255,255,0.08)",
                                            overflow: "hidden"
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: `${pct}%`,
                                                height: "100%",
                                                borderRadius: 999,
                                                background: "rgba(228,254,60,0.85)" // Accent
                                            }}
                                        />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
}